import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'
import replaceTextShortCodes, { validateRenderConditions } from 'functions/replaceTextShortCodes'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'

const Iframe = (props) => {
  const {
    context: componentContext,
    data: { value: rawValue },
    id,
    options,
    options: { renderConditions },
  } = props

  // Context
  const defaultContext = useContext(GlobalContext)
  const contextData = { ...defaultContext, ...componentContext }

  // Value
  const value = replaceTextShortCodes(rawValue, contextData)

  // Should Render
  const shouldRender = validateRenderConditions(renderConditions, contextData)
  if (!value || !shouldRender) return null

  // Style
  const style = deviceStyle(props)

  return (
    <AnimationWrapper options={options}>
      <div style={style}>
        <iframe
          allow="vr"
          allowFullScreen
          frameBorder="0"
          height="100%"
          src={value}
          title={`iframe-${id}`}
          width="100%"
        />
      </div>
    </AnimationWrapper>
  )
}

Iframe.propTypes = {
  context: PropTypes.object,
  data: PropTypes.object,
  id: PropTypes.string.isRequired,
  options: PropTypes.object,
}

Iframe.defaultProps = {
  data: {},
  options: {},
}

export default Iframe
